import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _26afc49f = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _271528c4 = () => interopDefault(import('..\\pages\\errors\\index.vue' /* webpackChunkName: "pages_errors_index" */))
const _0240e85a = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages_thank-you" */))
const _1d294bbd = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _94c1f086 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _c619374a = () => interopDefault(import('..\\pages\\upload-documents-success.vue' /* webpackChunkName: "pages_upload-documents-success" */))
const _20712604 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _68885e58 = () => interopDefault(import('..\\pages\\hcp\\diagnosis-information.vue' /* webpackChunkName: "pages_hcp_diagnosis-information" */))
const _734d96de = () => interopDefault(import('..\\pages\\hcp\\eligibility.vue' /* webpackChunkName: "pages_hcp_eligibility" */))
const _60dc9708 = () => interopDefault(import('..\\pages\\hcp\\getting-started.vue' /* webpackChunkName: "pages_hcp_getting-started" */))
const _dabc5d98 = () => interopDefault(import('..\\pages\\hcp\\health-insurance-information.vue' /* webpackChunkName: "pages_hcp_health-insurance-information" */))
const _2bb8f3e8 = () => interopDefault(import('..\\pages\\hcp\\patient-information.vue' /* webpackChunkName: "pages_hcp_patient-information" */))
const _07554d3e = () => interopDefault(import('..\\pages\\hcp\\pharmacy-information.vue' /* webpackChunkName: "pages_hcp_pharmacy-information" */))
const _10d4c230 = () => interopDefault(import('..\\pages\\hcp\\prescriber-information.vue' /* webpackChunkName: "pages_hcp_prescriber-information" */))
const _e7e387f2 = () => interopDefault(import('..\\pages\\hcp\\success.vue' /* webpackChunkName: "pages_hcp_success" */))
const _33c3ec3e = () => interopDefault(import('..\\pages\\patient\\eligibility.vue' /* webpackChunkName: "pages_patient_eligibility" */))
const _f4f05226 = () => interopDefault(import('..\\pages\\patient\\not-eligible.vue' /* webpackChunkName: "pages_patient_not-eligible" */))
const _15ca6905 = () => interopDefault(import('..\\pages\\patient\\patient-authorization.vue' /* webpackChunkName: "pages_patient_patient-authorization" */))
const _ed5d778a = () => interopDefault(import('..\\pages\\patient\\patient-authorization-success.vue' /* webpackChunkName: "pages_patient_patient-authorization-success" */))
const _e5890d90 = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _64ac7ae0 = () => interopDefault(import('..\\pages\\patient\\prescriber-information.vue' /* webpackChunkName: "pages_patient_prescriber-information" */))
const _43b23957 = () => interopDefault(import('..\\pages\\patient\\success.vue' /* webpackChunkName: "pages_patient_success" */))
const _4585ec5e = () => interopDefault(import('..\\pages\\pharmacy\\eligibility.vue' /* webpackChunkName: "pages_pharmacy_eligibility" */))
const _6967b52a = () => interopDefault(import('..\\pages\\pharmacy\\ncpdp.vue' /* webpackChunkName: "pages_pharmacy_ncpdp" */))
const _7248d4fd = () => interopDefault(import('..\\pages\\pharmacy\\not-eligible.vue' /* webpackChunkName: "pages_pharmacy_not-eligible" */))
const _b8438616 = () => interopDefault(import('..\\pages\\pharmacy\\patient-authorization.vue' /* webpackChunkName: "pages_pharmacy_patient-authorization" */))
const _9dd8edb0 = () => interopDefault(import('..\\pages\\pharmacy\\patient-information.vue' /* webpackChunkName: "pages_pharmacy_patient-information" */))
const _cdd9b620 = () => interopDefault(import('..\\pages\\pharmacy\\prescriber-information.vue' /* webpackChunkName: "pages_pharmacy_prescriber-information" */))
const _7eaeb147 = () => interopDefault(import('..\\pages\\pharmacy\\success.vue' /* webpackChunkName: "pages_pharmacy_success" */))
const _3a2cb32e = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _26afc49f,
    name: "error"
  }, {
    path: "/errors",
    component: _271528c4,
    name: "errors"
  }, {
    path: "/thank-you",
    component: _0240e85a,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _1d294bbd,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _94c1f086,
    name: "upload-documents"
  }, {
    path: "/upload-documents-success",
    component: _c619374a,
    name: "upload-documents-success"
  }, {
    path: "/errors/404",
    component: _20712604,
    name: "errors-404"
  }, {
    path: "/hcp/diagnosis-information",
    component: _68885e58,
    name: "hcp-diagnosis-information"
  }, {
    path: "/hcp/eligibility",
    component: _734d96de,
    name: "hcp-eligibility"
  }, {
    path: "/hcp/getting-started",
    component: _60dc9708,
    name: "hcp-getting-started"
  }, {
    path: "/hcp/health-insurance-information",
    component: _dabc5d98,
    name: "hcp-health-insurance-information"
  }, {
    path: "/hcp/patient-information",
    component: _2bb8f3e8,
    name: "hcp-patient-information"
  }, {
    path: "/hcp/pharmacy-information",
    component: _07554d3e,
    name: "hcp-pharmacy-information"
  }, {
    path: "/hcp/prescriber-information",
    component: _10d4c230,
    name: "hcp-prescriber-information"
  }, {
    path: "/hcp/success",
    component: _e7e387f2,
    name: "hcp-success"
  }, {
    path: "/patient/eligibility",
    component: _33c3ec3e,
    name: "patient-eligibility"
  }, {
    path: "/patient/not-eligible",
    component: _f4f05226,
    name: "patient-not-eligible"
  }, {
    path: "/patient/patient-authorization",
    component: _15ca6905,
    name: "patient-patient-authorization"
  }, {
    path: "/patient/patient-authorization-success",
    component: _ed5d778a,
    name: "patient-patient-authorization-success"
  }, {
    path: "/patient/patient-information",
    component: _e5890d90,
    name: "patient-patient-information"
  }, {
    path: "/patient/prescriber-information",
    component: _64ac7ae0,
    name: "patient-prescriber-information"
  }, {
    path: "/patient/success",
    component: _43b23957,
    name: "patient-success"
  }, {
    path: "/pharmacy/eligibility",
    component: _4585ec5e,
    name: "pharmacy-eligibility"
  }, {
    path: "/pharmacy/ncpdp",
    component: _6967b52a,
    name: "pharmacy-ncpdp"
  }, {
    path: "/pharmacy/not-eligible",
    component: _7248d4fd,
    name: "pharmacy-not-eligible"
  }, {
    path: "/pharmacy/patient-authorization",
    component: _b8438616,
    name: "pharmacy-patient-authorization"
  }, {
    path: "/pharmacy/patient-information",
    component: _9dd8edb0,
    name: "pharmacy-patient-information"
  }, {
    path: "/pharmacy/prescriber-information",
    component: _cdd9b620,
    name: "pharmacy-prescriber-information"
  }, {
    path: "/pharmacy/success",
    component: _7eaeb147,
    name: "pharmacy-success"
  }, {
    path: "/",
    component: _3a2cb32e,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
